import type { TFunction } from 'i18next'

export function formatBloodCollectionDateTime(value: string) {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleString('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  })
}

export function getHistoryStatusStyle(status: string) {
  const normalized = status.toUpperCase()
  if (normalized.includes('COMPLETED') || normalized.includes('DONE')) {
    return { bg: 'badge.green.20', color: 'badge.green.100' }
  }
  if (normalized.includes('REJECT') || normalized.includes('DEFER')) {
    return { bg: 'badge.red.20', color: 'badge.red.100' }
  }
  return { bg: 'badge.yellow.20', color: 'badge.yellow.100' }
}

export function translateHistoryStatus(t: TFunction, status: string): string {
  const normalized = status.toUpperCase().trim()

  const directKey = `laboratory_research.blood_collection.history_status.${normalized}`
  const direct = t(directKey)
  if (direct !== directKey) return direct

  if (normalized.includes('COMPLETED') || normalized.includes('DONE')) {
    return t('laboratory_research.blood_collection.history_status.COMPLETED')
  }
  if (normalized.includes('REJECT') || normalized.includes('DEFER')) {
    return t('laboratory_research.blood_collection.history_status.REJECTED')
  }
  if (normalized.includes('IN_PROGRESS') || normalized.includes('PROGRESS')) {
    return t('laboratory_research.blood_collection.history_status.IN_PROGRESS')
  }
  if (normalized.includes('WAIT')) {
    return t('laboratory_research.blood_collection.history_status.WAITING')
  }

  return status
}
